module.exports = __webpack_public_path__ + "img/project_8.382b2cca.jpg";